export default __webpack_public_path__ + "static/media/verify-success.12d9284f.svg";